import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export const FacilityIDValidation = z.object({
  value: z.string({ required_error: '[FacilityID] value is required' }),
})

export class FacilityID extends Model {
  static create({ value }: z.infer<typeof FacilityIDValidation>) {
    FacilityIDValidation.parse({ value })
    return new FacilityID(value)
  }

  static fromNumber({ value }: { value: number }) {
    return new FacilityID(value.toString())
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
